<template>
  <div v-loading="loading"></div>
</template>

<script>
import LoginAPI from "@/api/hzmb-gh/LoginAPI";

export default {
  data() {
    return {
      loading: false,
    };
  },
  computed: {
    serviceType() {
      if (this.$route.params.serviceType) return this.$route.params.serviceType;
      if (this.$route.meta.serviceType) return this.$route.meta.serviceType;
      return null;
    },
    isPerson() {
      return ["HZMB_H_FIRST_PERSON", "HZMB_H_CANCEL_PERSON"].includes(
        this.serviceType
      );
    },
    isCompany() {
      return ["HZMB_H_FIRST_COMP", "HZMB_H_CANCEL_COMP"].includes(
        this.serviceType
      );
    },
  },
  created() {
    const code = this.$route.query.code || null;
    const accountData = JSON.parse(localStorage.getItem("accountData")) || null;

    if (code && this.serviceType) {
      this.accountLogin(code);
    } else {
      if (!accountData) {
        this.$message({
          type: "error",
          message: this.$t("message.accountLoginFailed"),
        });
      }
      this.jump();
    }
  },
  methods: {
    // 一戶通登入
    async accountLogin(code) {
      if (!this.isPerson && !this.isCompany) return;

      this.loading = true;

      try {
        let result;
        if (this.isPerson)
          result = await LoginAPI.account(code, null, this.serviceType);
        if (this.isCompany)
          result = await LoginAPI.entityAccount(code, null, this.serviceType);

        let { data, headers } = result;
        localStorage.setItem("accountData", JSON.stringify(data));
        localStorage.setItem("authentication", headers.authentication);

        this.$router.replace(`/verification/hzmb-h/${this.serviceType}`);
      } catch (error) {
        if (error.message.indexOf("401") === -1) {
          this.$error(error);
        }
        if (error.status !== 401) {
          this.jump();
        }
      } finally {
        this.loading = false;
      }
    },
    // 跳轉
    jump() {
      const serviceType = this.serviceType;
      let path;
      switch (serviceType) {
        case "HZMB_H_FIRST_PERSON":
          path = "/hzmb-truck-mo-personal";
          break;
        case "HZMB_H_FIRST_COMP":
          path = "/hzmb-truck-mo-company";
          break;
        default:
          break;
      }
      this.$router.push(path);
    },
  },
};
</script>

<style lang="scss" scoped></style>
